import React, { Component } from "react";
import { findAuthorizedId } from "../../../../domain/validation/utils";
import { FormattedMessage, defineMessages } from "react-intl";
import isEmpty from "assets/scripts/utils/isEmpty";
import { REQUIRED } from "../../../../constants/FormMessages";
import mapBackendErrors from "assets/scripts/utils/mapBackendErrors";
import Form from "../../../common/form/Form/Form";
import TextFormGroup from "assets/scripts/components/common/form/TextFormGroup/TextFormGroup";
import ValidationFieldset from "assets/scripts/components/common/form/ValidtationFieldset/ValidationFieldset";
import getMaxLengthError from "assets/scripts/utils/getMaxLengthError";
import { showAuthorized, showRelationship } from "assets/scripts/components/containers/public/Registration/registrationUtils";
import AuthorizedInput, { getErrors as getAuthorizedErrors } from "../AuthorizedInput/AuthorizedInput";
import EmailAndRelationshipInputs, { getErrors as getEmailAndRelationshipErrors } from "../EmailAndRelationshipInputs/EmailAndRelationshipInputs";
const messages = defineMessages({
    submit: {
        id: "forms.accountValidation.submit",
        defaultMessage: "OK"
    },
    firstNameLabel: {
        id: "forms.accountValidation.firstName.label",
        defaultMessage: "Your first name"
    },
    lastNameLabel: {
        id: "forms.accountValidation.lastName.label",
        defaultMessage: "Your last name"
    }
});
export function getNameErrors(value) {
    return {
        firstName: isEmpty(value.firstName) ? REQUIRED : getMaxLengthError(value.firstName, 50),
        lastName: isEmpty(value.lastName) ? REQUIRED : getMaxLengthError(value.lastName, 50)
    };
}
export function getValidationErrors(value, validationInfo) {
    const validation = {};
    for (const { id } of validationInfo) {
        if (isEmpty(value.validation[id])) {
            validation[id] = REQUIRED;
        }
    }
    return validation;
}
function getErrors(value, deceased, validationInfo) {
    return {
        ...getAuthorizedErrors(value, deceased),
        ...getNameErrors(value),
        ...getEmailAndRelationshipErrors(value, deceased),
        validation: getValidationErrors(value, validationInfo)
    };
}
export default class AccountValidationForm extends Component {
    constructor(props, context) {
        super(props, context);
        this._handleFirstNameChange = (firstName) => this._handleValueChange({ firstName });
        this._handleLastNameChange = (lastName) => this._handleValueChange({ lastName });
        this._handleValidationChange = (validation) => {
            this._handleValueChange({ validation });
        };
        this._handleValueChange = (value) => {
            this.setState(prevState => ({
                value: {
                    ...prevState.value,
                    ...value
                }
            }));
        };
        const { deceased } = props;
        this.state = {
            value: {
                authorized: !showAuthorized(deceased),
                firstName: "",
                lastName: "",
                email: "",
                relationship: showRelationship(deceased) ? "" : "Self",
                validation: {}
            }
        };
        this._handleSubmit = this._handleSubmit.bind(this);
    }
    render() {
        const { props, state } = this;
        const { deceased } = props;
        const { value } = state;
        const { validation: validationErrors, ...errors } = getErrors(value, props.deceased, props.customFields);
        const isValid = Object.values(errors).every(it => it == null)
            && Object.values(validationErrors).every(it => it == null);
        const { globalError, backendErrors } = mapBackendErrors(props.fieldErrors);
        return (<Form isBusy={props.isLoading} isValid={isValid} onSubmit={this._handleSubmit} submitLabel={messages.submit} error={globalError}>
				<fieldset className="fieldset">
					<legend>
						<span className="u-isVisuallyHidden">
							<FormattedMessage id="forms.accountValidation.legend" defaultMessage="Account Validation Information"/>
						</span>
					</legend>

					<AuthorizedInput deceased={deceased} value={value} errors={errors} backendErrors={backendErrors} onChange={this._handleValueChange}/>

					<TextFormGroup name="firstName" label={messages.firstNameLabel} value={value.firstName} onChange={this._handleFirstNameChange} error={errors.firstName} required inputProps={{
            autoComplete: "given-name"
        }}/>

					<TextFormGroup name="lastName" label={messages.lastNameLabel} value={value.lastName} onChange={this._handleLastNameChange} error={errors.lastName} required inputProps={{
            autoComplete: "family-name"
        }}/>

					<EmailAndRelationshipInputs deceased={deceased} value={value} errors={errors} backendErrors={backendErrors} onChange={this._handleValueChange}/>

					<ValidationFieldset value={value.validation} onChange={this._handleValidationChange} errors={validationErrors} requirements={props.customFields} locale={props.locale}/>
				</fieldset>
			</Form>);
    }
    _handleSubmit() {
        const value = {
            ...this.state.value,
            referenceNumber: this.props.validation.referenceNumber,
            pin: this.props.validation.pin,
            relationship: this.state.value.relationship,
            validation: this.state.value.validation,
        };
        this.props.startValidation(value);
        const authId = findAuthorizedId(value.firstName, value.lastName, this.props.authIndividuals);
        if (authId) {
            this.props.setAuthId(authId);
            this.props.sendValidation(value, authId);
        }
        else {
            this.props.openModal({ modalId: "authIndividual", triggerId: "" });
        }
    }
}



// WEBPACK FOOTER //
// ./src/assets/scripts/components/forms/public/AccountValidationForm/AccountValidationForm.tsx